<template>
  <div class="alarmRule">
    <div class="title">
      <p><span>告警规则</span></p>
    </div>
    
    <div class="content">
      <div class="contain">
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon><Plus/></el-icon>新增规则
        </el-button>
        
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png"/>
          </template>
          <el-table-column label="告警名称" prop="name"/>
          <el-table-column label="设备" prop="equipmentNameList">
            <template #default="{ row }">
              <el-tooltip v-if="row.equipmentNameList.length > 3"
                          :content="row.equipmentNameList.join(',')" placement="top">
                <span>{{ row.equipmentNameList.slice(0, 3).join(',') }}...</span>
              </el-tooltip>
              <span v-else>{{ row.equipmentNameList.join(',') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="type">
            <template #default="scope">{{ scope.row.type === 1 ? '自定义' : '系统' }}</template>
          </el-table-column>
          <el-table-column label="设备范围类型" prop="chooseFlag">
            <template #default="scope">{{ scope.row.chooseFlag === 1 ? '选中' : '排除' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime"/>
          <el-table-column label="告警规则" prop="targetList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.targetList" :key="index">
                <span :class="'level level'+item.level">{{ item.levelStr }}</span>
                {{ item.dictName }}{{ item.symbol }}{{ item.value }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="告警开关">
            <template #default="scope">
              <el-switch v-model="scope.row.switchFlag"
                         @change="(value) => handleSwitchChange(value, scope.row.id)"
                         style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"/>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120px">
            <template #default="scope">
              <div class="opacity">
                <span class="editClass btn" @click="editClick(scope.row.id,scope.row)">编辑</span>
                <span class="editClass delBtn" @click="delClick(scope.row.id,scope.row)" v-if="scope.row.type===1">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <div v-if="tableData.length>0" class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog v-model="dialogFormVisible" @close="handleDialogClose" :close-on-click-modal="false"
               :title="formData.id?'编辑规则':'新建规则'" style="min-width: 1008px" width="70%">
      <el-form ref="fromRef" :inline="true" :model="formData" :rules="formRules">
        <el-form-item label="规则名称:" prop="name" style="width: 100%">
          <el-input v-model="formData.name" placeholder="请输入规则名称"/>
        </el-form-item>
        
        <el-form-item label="设备范围类型:" prop="chooseFlag" style="width: 100%" v-if="formData.id && formType === 0">
          <el-select v-model="formData.chooseFlag" placeholder="请选择设备范围">
            <el-option label="选中" value="1"/>
            <el-option label="排除" value="0"/>
          </el-select>
        </el-form-item>
        
        <el-form-item class="topFormItem topFormItem2" label="设备" prop="equipmentIdList1" style="width: 100%">
          <el-select ref="elSelectTable" v-model="formData.equipmentIdList1" :disabled="true"
                     :popper-append-to-body="false" :suffix-icon="Plus" class="timeSelect" multiple
                     popper-class="timeSelectPopper" @click="selectTimeFun">
            <el-option v-for="(item,index) in formData.equipmentIdList" :key="index"
                       :label="item.value" :value="item.key"/>
          </el-select>
        </el-form-item>
        
        <p class="line" style="width: 100%;height: 1px;background-color: #eee;margin: 25px 0"/>
        
        <el-form-item label="自动派单:" prop="autoFlag" style="width: calc(100% - 32px)">
          <el-switch v-model="formData.autoFlag"/>
        </el-form-item>
        
        <div v-for="(item,index) in formData.mobiles" :key="index" class="notificationBox" style="width: 100%">
          <el-form-item label="通知人手机号:">
            <el-input v-model="item.mobile" :disabled="item.disabled" placeholder="请输入手机号"/>
          </el-form-item>
          <el-icon v-if="formData.mobiles.length > 1" class="delIcon" @click="notificationDelClick(index)">
            <CircleClose/>
          </el-icon>
          <el-icon v-if="index===formData.mobiles.length-1" class="addIcon" @click="notificationAddClick">
            <CirclePlus/>
          </el-icon>
        </div>
        
        <p class="line" style="width: 100%;height: 1px;background-color: #eee;margin: 25px 0"/>
        
        <el-form-item v-show="formData.equipmentIdList.length>0" label="告警模版:" prop="template"
                      v-if="!formData.id || formType !== 0">
          <el-select v-model="formData.template" class="item" clearable placeholder="请选择告警模版"
                     @change="templateChange">
            <el-option v-for="(item,index) in selectList" :key="index" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        
        <div v-for="(item,index) in formData.targetJsonStr"
             v-show="formData.equipmentIdList.length >0 || formType === 0"
             :key="index" class="rowItem">
          <el-form-item>
            <el-select v-model="item.level" class="item" clearable placeholder="请选择告警级别"
                       :disabled="formType === 0 && formData.id">
              <el-option :value="1" label="紧急告警"/>
              <el-option :value="2" label="主要告警"/>
              <el-option :value="3" label="次要告警"/>
              <el-option :value="4" label="警告告警"/>
            </el-select>
          </el-form-item>
          
          <el-form-item class="data">
            <el-select v-model="item.dictId" class="item" filterable placeholder="请选择监控指标"
                       @change="handleChange($event,index)" :disabled="formType === 0 && formData.id">
              <el-option label="未上报时间" value="-1" v-if="formType === 0 && formData.id"/>
              <el-option label="离线时间" value="-2" v-if="formType === 0 && formData.id"/>
              <el-option v-for="(item_d,index_d) in dataList" :key="index_d" :label="item_d.name" :value="item_d.id"/>
            </el-select>
          </el-form-item>
          
          <el-form-item class="data">
            <el-input v-model="item.value" class="item" placeholder="请输入告警值">
              <template #prepend>
                <span v-if="item.dictId === '-1' || item.dictId === '-2'" class="time-label">多久(s)</span>
                <el-select v-else v-model="item.symbol" class="item" placeholder="请选择"
                           :disabled="formType === 0 && formData.id">
                  <el-option label=">" value=">"/>
                  <el-option label="<" value="<"/>
                  <el-option label="=" value="="/>
                  <el-option label=">=" value=">="/>
                  <el-option label="<=" value="<="/>
                </el-select>
              </template>
            </el-input>
          </el-form-item>
          
          <el-icon v-if="formData.targetJsonStr.length>1 && (!formData.id || formType !== 0)"
                   class="delIcon" @click="delItemClick(index)">
            <CircleClose/>
          </el-icon>
          <el-icon v-if="index===formData.targetJsonStr.length-1 && (!formData.id || formType !== 0)"
                   class="addIcon" @click="addItemClick">
            <CirclePlus/>
          </el-icon>
        </div>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button class="cancle" @click="dialogFormVisible=false">取消</el-button>
          <el-button class="confrim" type="primary" @click="save()">保存</el-button>
        </span>
      </template>
    </el-dialog>
    
    <DeviceSelect :checkDeviceList="formData.equipmentIdList" :deviceVisible="deviceVisible"
                  @checkDeviceListFun="checkDeviceListFun" @deviceVisibleFun="deviceVisibleFun"/>
  </div>
</template>

<script setup>
import {h, onMounted, ref, watch} from "vue"
import './alarmRule.less'
import DeviceSelect from '@/components/deviceSelect'
import {CircleClose, CirclePlus, Plus} from '@element-plus/icons-vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router'
import qs from "qs"
import {getAllTreeApi} from "@/api/modules/strategy"
import {
  delAlarmRuleAPi,
  getAlarmRuleDetailAPi,
  getAlarmRuleListAPi,
  getAlarmSelectListAPi,
  getProductSelectApi,
  getUserSelectListAPi,
  listSelectByPrefixEquipmentIdApi,
  saveAlarmRuleAPi,
  switchFlagApi
} from "@/api/modules/alarm"


let router = useRouter()
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref(0)
let tableData = ref([])
let loading = ref(false)
let dialogFormVisible = ref(false)
let productList = ref([])
let dataList = ref([])
let fromRef = ref()
let deviceVisible = ref(false)
let treeRef1 = ref()
let allTree = ref()
let selectList = ref([])
let memberList = ref([])
let formType = ref(1) // ✅ 初始化为 1（自定义类型），不是 0

// ✅ formData 必须包含所有字段
let formData = ref({
  id: 0,
  name: '',
  equipmentIdList: [],
  equipmentIdList1: [], // ✅ 必须声明
  memberIdList: [],
  template: '',
  chooseFlag: '1',
  autoFlag: true,
  mobiles: [{ mobile: '', disabled: false }],
  targetJsonStr: [{ level: '', dictId: '', symbol: '>=', value: '' }]
})

let formRules = ref({
  name: [{required: true, message: '请输入规则名称', trigger: 'blur'}],
  equipmentIdList1: [
    {
      validator: (rule, value, callback) => {
        // 当chooseFlag为'1'(选中)时，设备必填
        if (formData.value.chooseFlag === '1') {
          if (!value || value.length === 0) {
            callback(new Error('请选择设备'))
          } else {
            callback()
          }
        } else {
          // 当chooseFlag为'0'(排除)时，设备可选
          callback()
        }
      },
      trigger: ['blur', 'change']  // 添加change触发
    }
  ],
  memberIdList: [{required: true, message: '请选择通知人', trigger: 'blur'}],
  level: [{required: true, message: '请选择告警级别', trigger: 'blur'}],
})


const handleDialogClose = () => {
  formType.value = 1 // ✅ 重置为自定义类型
  dataList.value = []
  formData.value = {
    id: 0,
    name: '',
    equipmentIdList: [],
    equipmentIdList1: [],
    memberIdList: [],
    template: '',
    chooseFlag: '1',
    autoFlag: true,
    mobiles: [{ mobile: '', disabled: false }],
    targetJsonStr: [{ level: '', dictId: '', symbol: '>=', value: '' }]
  }
}
const isTargetJsonStrEmpty = (targetJsonStr) => {
  if (!targetJsonStr || targetJsonStr.length === 0) return true
  
  return targetJsonStr.every(item => {
    // 检查所有关键字段是否为空
    return !item.level && !item.dictId && !item.value
  })
}
const handleSizeChange = (e) => {
  pageSize.value = e
  getListFun()
}

const pageChange = (e) => {
  pageNumber.value = e
  getListFun()
}

const getListFun = () => {
  loading.value = true
  getAlarmRuleListAPi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list.map(item => ({
        ...item,
        switchFlag: item.switchFlag === 1
      }))
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({ type: 'error', message: res.data.message })
    }
  }).catch(err => console.log(err))
}
// 辅助函数：确保数值后面有's'
const ensureValueHasS = (value) => {
  if (!value && value !== 0) return value
  
  const strValue = String(value).trim()
  
  // 如果已经以's'结尾，直接返回
  if (strValue.endsWith('s') || strValue.endsWith('S')) {
    return strValue
  }
  
  // 尝试提取数值部分
  const match = strValue.match(/^(\d+\.?\d*)/)
  if (match) {
    return match[1] + 's'
  }
  
  return strValue
}
const handleSwitchChange = (value, rowId) => {
  switchFlagApi(qs.stringify({id: Number(rowId), switchFlag: Number(value)}))
    .then(() => ElMessage.success('状态更新成功'))
    .catch(() => {
      const item = tableData.value.find(item => item.id === rowId)
      item.switchFlag = !value
    })
}

const getProductListFun = () => {
  getProductSelectApi().then(res => {
    if (res.data.code === 0) productList.value = res.data.result
  }).catch(err => console.log(err))
}

const productChange = (idx) => {
  formData.value.targetJsonStr[idx].dictId = ''
  getDataListFun()
}

const getDataListFun = () => {
  if (!formData.value?.equipmentIdList1?.length) {
    dataList.value = []
    return
  }
  
  listSelectByPrefixEquipmentIdApi(qs.stringify({
    equipmentIdList: formData.value.equipmentIdList1.join(',')
  })).then(res => {
    if (res.data.code === 0) dataList.value = res.data.result || []
  }).catch(err => console.log(err))
}

const handleChange = (value, index) => {
  const optionExists = dataList.value.some(option => option.id === value)
  if (!optionExists) formData.value.targetJsonStr[index].dictId = ''
}

const templateChange = () => {
  for (let item of selectList.value) {
    if (formData.value.template === item.id) {
      formData.value.targetJsonStr = item.targetList
      break
    }
  }
  formData.value.targetJsonStr.forEach((item, i) => handleChange(item.dictId, i))
}

const addClick = () => {
  dialogFormVisible.value = true
  formType.value = 1 // ✅ 强制为自定义
  formData.value = {
    id: 0,
    name: '',
    equipmentIdList: [],
    equipmentIdList1: [],
    memberIdList: [],
    template: '',
    chooseFlag: '1',
    autoFlag: true,
    mobiles: [{ mobile: '', disabled: false }],
    targetJsonStr: [{ level: '', dictId: '', symbol: '>=', value: '' }]
  }
}

const editClick = (id, row) => {
  dialogFormVisible.value = true
  formType.value = row.type
  
  getAlarmRuleDetailAPi(qs.stringify({id})).then(res => {
    if (res.data.code === 0) {
      const result = res.data.result
      formData.value = {
        id: result.id,
        name: result.name,
        equipmentIdList: result.equipmentList || [],
        memberIdList: result.memberIdList || [],
        autoFlag: result.autoFlag == 1,
        mobiles: (result.mobileList || []).map(mobile => ({ mobile, disabled: true })),
        targetJsonStr: result.targetList || [],
        chooseFlag: String(result.chooseFlag)
      }
      
      // ✅ 转换 equipmentIdList1
      formData.value.equipmentIdList1 = formData.value.equipmentIdList
        .filter(item => item && item.key)
        .map(item => item.key)
      
      if (formData.value.equipmentIdList1.length) getDataListFun()
    }
  }).catch(err => console.log(err))
}

const addItemClick = () => {
  formData.value.targetJsonStr.push({
    level: '', dictId: '', symbol: '>=', value: ''
  })
}

const delItemClick = (index) => {
  formData.value.targetJsonStr.splice(index, 1)
}

const notificationAddClick = () => {
  const lastMobile = formData.value.mobiles[formData.value.mobiles.length - 1]
  if (!lastMobile.disabled && lastMobile.mobile) {
    formData.value.mobiles.push({ mobile: '', disabled: false })
  } else if (lastMobile.disabled) {
    formData.value.mobiles.push({ mobile: '', disabled: false })
  } else {
    ElMessage({ type: 'info', message: '请输入手机号' })
  }
}

const notificationDelClick = (index) => {
  formData.value.mobiles.splice(index, 1)
}

const selectTimeFun = () => {
  deviceVisible.value = true
}

const deviceVisibleFun = (data) => {
  deviceVisible.value = data
}

const checkDeviceListFun = (data) => {
  formData.value.equipmentIdList = data
}

const save = function () {
  // 提交表单
  if (fromRef) {
    fromRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        let flag = true
        // for (let i = 0; i < formData.value.mobiles.length; i++) {
        //   if (formData.value.mobiles[i].code === '') {
        //     flag = false
        //   }
        // }
        if (flag) {
          let data = JSON.parse(JSON.stringify(formData.value))
           if (Array.isArray(data.targetJsonStr)) {
            data.targetJsonStr.forEach(item => {
              // 删除 dictName
              delete item.dictName
              
              // 给 value 的值加 's'，如果还没有 's' 的话
              if (item.value !== undefined && item.value !== null) {
                const strValue = String(item.value).trim()
                
                // 检查是否已经以 's' 或 'S' 结尾
                if (!strValue.endsWith('s') && !strValue.endsWith('S')) {
                  item.value = strValue + 's'
                } else {
                  // 如果已经有 's'，保持原样
                  item.value = strValue
                }
              }
            })
          }
  data.targetJsonStr = JSON.stringify(data.targetJsonStr)
          // data.equipmentIdList = data.equipmentIdList.join(',')
          data.equipmentIdList = data.equipmentIdList1.join(',')
          data.memberIdList = data.memberIdList.join(',')
          data.autoFlag = data.autoFlag ? 1 : 0
          for (let i = 0; i < data.mobiles.length; i++) {
            data.mobiles[i] = data.mobiles[i].mobile
          }
          data.mobiles = data.mobiles.join(',')
          for (let i = 0; i < data.targetJsonStr.length; i++) {
            delete data.targetJsonStr[i].dictName
          }
          delete data.equipmentIdList1
          delete data.memberIdList


          saveAlarmRuleAPi(qs.stringify(data)).then(res => {
            if (res.data.code === 0) {
              getListFun()
              dialogFormVisible.value = false
            } else {
              ElMessage({
                type: 'error',
                message: res.data.message
              })
            }
          }).catch(err => {
            console.log(err);
          })
        } else {
          ElMessage({
            type: 'info',
            message: '请输入验证码'
          })
        }
      }
    })
  }
}

const delClick = (id, row) => {
  ElMessageBox.confirm('请确认是否要删除此告警规则，删除后数据不可恢复', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除规则',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此告警规则，删除后数据不可恢复')
    ])
  }).then(() => {
    delAlarmRuleAPi(qs.stringify({id})).then(res => {
      if (res.data.code === 0) {
        getListFun()
        ElMessage({ type: 'success', message: '删除成功' })
      } else {
        ElMessage({ type: 'error', message: res.data.message })
      }
    }).catch(err => console.log(err))
  }).catch(() => {
    ElMessage({ type: 'info', message: '已取消删除' })
  })
}

const onlySelect = (data) => {
  data.forEach(item => {
    if (item.type == 1) item.id = item.id + '_' + item.type
    if (item.subList?.length) onlySelect(item.subList)
  })
}


watch(() => formData.value?.equipmentIdList, (newVal) => {
  if (!formData.value) return
  formData.value.equipmentIdList1 = (newVal || [])
    .filter(item => item && item.key)
    .map(item => item.key)
}, { deep: true }) // ✅ 移除 immediate

watch(() => formData.value?.equipmentIdList1, (newVal) => {
  if (!dialogFormVisible.value || !newVal || newVal.length === 0) {
    dataList.value = []
    return
  }
  getDataListFun()
}) // ✅ 移除 immediate


onMounted(() => {
  getListFun()
  getProductListFun()
  
  getAllTreeApi().then(async res => {
    if (res.data.code === 0) {
      let data = res.data.result
      await onlySelect(data)
      allTree.value = data
    }
  }).catch(err => console.log(err))
  
  getAlarmSelectListAPi().then(res => {
    if (res.data.code === 0) selectList.value = res.data.result
  }).catch(err => console.log(err))
  
  getUserSelectListAPi().then(res => {
    if (res.data.code === 0) memberList.value = res.data.result
  }).catch(err => console.log(err))
})
</script>

<style lang="less">
.topFormItem2 {
  .el-select .el-select__wrapper.is-disabled, .el-select .el-icon.el-select__caret.el-select__icon {
    cursor: pointer !important;
  }
}
.el-tooltip__popper {
  max-width: 400px;
  word-break: break-word;
}
</style>